const SET_COUNTRIES = 'SET_COUNTRIES';
const SET_COUNTRIES_REFACTORED = 'SET_COUNTRIES_REFACTORED';
const SET_CITIES = 'SET_CITIES';
const SET_REGIONS = 'SET_REGIONS';
const SET_CITIES_REFACTORED = 'SET_CITIES_REFACTORED';
const SET_REGIONS_REFACTORED = 'SET_REGIONS_REFACTORED';

export { SET_COUNTRIES, SET_COUNTRIES_REFACTORED, SET_CITIES, SET_REGIONS, SET_CITIES_REFACTORED, SET_REGIONS_REFACTORED };
